var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskUploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 10C13.1193 10 12 11.1193 12 12.5L12 27.5C12 28.8807 13.1193 30 14.5 30H24.5C25.8807 30 27 28.8807 27 27.5V16.7678C27 16.1047 26.7366 15.4688 26.2678 15L22 10.7322C21.5312 10.2634 20.8953 10 20.2322 10L14.5 10Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25C18.8096 25 18.25 24.4404 18.25 23.75L18.25 19.2678L16.6339 20.8839C16.1457 21.372 15.3543 21.372 14.8661 20.8839C14.378 20.3957 14.378 19.6043 14.8661 19.1161L18.6161 15.3661C19.1043 14.878 19.8957 14.878 20.3839 15.3661L24.1339 19.1161C24.622 19.6043 24.622 20.3957 24.1339 20.8839C23.6457 21.372 22.8543 21.372 22.3661 20.8839L20.75 19.2678L20.75 23.75C20.75 24.4404 20.1904 25 19.5 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskUploadIcon);
export default __webpack_public_path__ + "static/media/ask-upload-icon.9bd63a85df6ce6d9a7b6a7a38873c48d.svg";
export { ForwardRef as ReactComponent };